<template lang="pug">
  .resource-view-wrapper
    include Resources.pug
</template>

<script>
import _ from "underscore"
import ResourceHomeBlock from '@/components/resources/ResourceHomeBlock'
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: 'Resources',
  props: [
  ],
  computed: mapState([
    "context", "token",
  ]),
  components: {
    ResourceHomeBlock,
  },
  data () {
    return {
      tree: null,
      plan: null,
    }
  },
  async created() {
    // Me information
    const meResponse = await Api.me(this.token)
    const dataMe = meResponse.data
    const plan = dataMe.plan
    this.plan = plan

    const treeResponse = await this.$wagtail.getResourceTree()
    const data = treeResponse.data
    this.tree = _.pick(data, "families", "topics")
  },
}
</script>

<style lang="scss">
@import "./../../variables";

.resource-view-wrapper {
  @import "Resources";
}

</style>



// WEBPACK FOOTER //
// src/components/resources/Resources.vue